import { Component, OnInit, OnDestroy, HostListener} from '@angular/core';
import { Subscription, BehaviorSubject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

import { IWayPoint, SelectedCoordinate } from './itinerary';
import { IMapSettings } from '../../map-settings/settings';
import { ItinenaryCrudDialog } from './itinenary-crud/itinenary-crud.dialog'
import { ConfirmDialogComponent } from '../../../shared/confirm-dialog/confirm-dialog.component';
import { Router } from '@angular/router';

//Services
import { FileDataService } from '../services/file-data.service';
import { SettingService } from '../../services/setting.service';
import { MapSharedService } from '../services/map-shared.service';
import { IFileExtension } from '../file-import/file-import';
import { AuthService } from 'src/app/user/services/auth.service';
import * as moment from 'moment';

@Component({
  selector: 'app-itinenary-list',
  templateUrl: './itinenary-list.component.html',
  styleUrls: ['./itinenary-list.component.scss'],

})
export class ItinenaryListComponent implements OnInit, OnDestroy {
  // Table Column Values
  displayedColumns: string[] = ['itineraryIndex', 'itineraryName', 'longitude', 'latitude']; //
  itinenaryDataSource = new BehaviorSubject<IWayPoint[]>([]);
  subs: Subscription[] = [];
  currentItnName: string = '';
  previousSelected: any[];
  public data: object[];
  // Tracks or stores selected table item
  selection = new SelectionModel<IWayPoint>(true);
  multipleSelect = [];
  ItemFilteredList: any[] = []
  selectedItem: any;
  highlightedRows: any[] = [];
  highlightedRow = []
  ItemFilteredLists: any[] = [];
  public keypressed;
  globalClick: any;
  fileExportFormatList: IFileExtension[] = [];
  // Selected Coordinate type in MAP settings
  coordinateType: number = SelectedCoordinate.DD;
  // Toggles enable and disable of Shift UP and DOWN direction(Table Operations)
  enableShiftUp: boolean = false;
  enableShiftDown: boolean = false;
  isDrawPolygon: boolean = false;
  disabledUTurn: boolean = false;

  // Total Distance Time computed for current itinerary
  distanceTime: any = null;
  enablePrompt: boolean = false;
  reloadFiledata: any;
  currentItineraryDetails: IWayPoint[] = [];
  selectedMarker: any;
  distances: any[] = [];
  totalDistances: any;
  totalTimes: any;
  routeMarkerList: L.Marker[] = [];
  routePopupContentList: string[] = [];
  initValMultiSelect: boolean = false;
  // const markers = new Marker([lat, long], { draggable: true }).setIcon(displayIcon);
  constructor(private fileService: FileDataService,
    private mapService: MapSharedService,
    private settingService: SettingService,
    private crudDialog: MatDialog,
    private confirmDialog: MatDialog,
    private authService: AuthService, 
    private router: Router  
  ) {
  }

  ngOnInit() {
    this.getCurrentItineraryTableData();
    this.onTableSelectionChanges();
    this.onMapSettingsChanges();
    this.getTotalDistanceTime();
    this.getItineraryName();
    // SCROLL BAR MOVE BASED ON ID
    this.subs.push(this.fileService.selectrdMarker$.subscribe(marker => {
      if (marker) {
        this.highlightRows(marker.id);
        let idValue = marker.id;
        this.scrollToId(idValue);
      }
    })
    )
    this.returndata();
    this.returnRouteMark();
    this.returnRoutePopup()
  }
  returndata() {
    return this.fileService.distanceWaypoint
  }
  returnRouteMark() {
    return this.fileService.routeMarker;
  }
  returnRoutePopup() {
    return this.fileService.routePopup;
  }
  scrollToId(id: any) {
    let constent = document.getElementById(id)
    constent.scrollIntoView({ block: 'center', behavior: 'smooth', inline: 'nearest' });
  }

  @HostListener('document:mousedown', ['$event.target'])
  onGlobalClick(event) {
    this.globalClick = event
    this.fileService.isDisableUTurn = false;
    const deleteOptions = (event.innerText !== "delete") ? true : false;
    const upOptions = (event.innerText !== "arrow_downward") ? true : false;
    const downOptions = (event.innerText !== "arrow_upward") ? true : false;
    if (deleteOptions && upOptions && downOptions && this.fileService.isMultipleRowSelected == true) {
      this.selection.selected.forEach(multipleItem => {
        this.selection.deselect(multipleItem);
      });
    }
    this.disabledUTurn = this.fileService.isDisableUTurn;
    this.fileService.isMultipleRowSelected = false;
  }

  getCurrentItineraryTableData() {
    // Watch for changes when file is uploaded or waypoint[] altered  
    this.subs.push(
      this.fileService.currentItinenary$.subscribe(
        res => {
          this.isDrawPolygon = this.fileService.isDrawPolygon;
          this.disabledUTurn = this.fileService.isDisableUTurn;
          this.itinenaryDataSource.next(res);
        })
    );
  }

  onTableSelectionChanges() {
    // Watch for changes on selected item in tables
    this.subs.push(
      this.selection.changed.subscribe(res => {
        if (res.added.length || res.removed.length) {
          this.enableDisableShift();
          this.displaySelectedItineraryitem(event);
          if (this.selection.selected.length >= 1) this.fileService.isMultipleRowSelected = true;
        }
      })
    );
  }

  onMapSettingsChanges() {
    // Watch for any changes for `coordinate` type and `addWayPointPrompt` in MAP SETTINGS 
    this.subs.push(
      this.settingService.currentMapSettings$.subscribe(
        (currentData: IMapSettings) => {
          if (currentData) {
            this.coordinateType = currentData.selectedCoordinate | 0;
            this.enablePrompt = currentData.addWayPointPrompt;
          }
        })
    );
  }

  getTotalDistanceTime() {
    // Watch for any Distance Time computation data
    this.subs.push(
      this.mapService.getItineraryDistanceTime$.subscribe(
        (itineraryDistanceTime: any) => {
          this.distanceTime = itineraryDistanceTime;
        })
    );
  }

  getItineraryName() {
    // Watch for any change in current Itinerary file name
    this.subs.push(
      this.fileService.currentItineraryName$.subscribe(
        (name: string) => {
          if (name) {
            this.reloadFiledata = this.fileService.tempRoutefile;
            if (this.fileService.isTempRoute == false) {
              this.currentItnName = name;
            }
            else {
              var fileUserName = this.reloadFiledata.responseData.fileName.split("_");
              if (this.fileService.currentUserName.firstName == fileUserName[0]) {
                var userFileRemove = "";
                fileUserName.forEach(element => {
                  if (this.fileService.currentUserName.firstName != element)
                    userFileRemove = userFileRemove + element + "_";
                });
                this.currentItnName = userFileRemove.substring(0, userFileRemove.length - 1);
              }
            }
          }
        })
    );
  }

  /**
   * Any changes to ITINERARY NAME input field 
   * is updated to file-import component
   */
  onItnNameChange(event: any) {
    const name = event.target.value
    this.fileService.changeItineraryName(name)
  }

  shiftItinerary(direction: string) {
    this.fileService.writeLog("shiftItinerary-start").subscribe((res: any) => {
      if (res.responseCode != null && res.responseCode.statusCode === 401) {
        this.authService.logout();
        this.router.navigate(['/user/login']);
      } else {
        const selectedItinerary = this.selection.selected[0];
        const oldIndex = this.itinenaryDataSource.getValue().findIndex(item => item === this.highlightedRows[0])
        const newIndex = direction === 'up' ? oldIndex - 1 : oldIndex + 1;
    
        this.itinenaryDataSource.next([...this.moveItems(this.itinenaryDataSource.getValue(), oldIndex, newIndex)])
        this.enableDisableShift();
        this.fileService.changeItinenaryData(this.itinenaryDataSource.getValue(), true);
        this.fileService.writeLog("shiftItinerary-end").subscribe((data: any) => {})
      }
    },
      (err) => console.log("Error while shift itinerary: ", err)
    ); 
  }

  moveItems(arr: IWayPoint[], oldIndex: number, newIndex: number) {
    while (oldIndex < 0) {
      oldIndex += arr.length;
    }
    if (newIndex < 0 || newIndex >= arr.length) {
      return arr;
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    return arr;
  }

  dropTable(event: CdkDragDrop<IWayPoint[]>) {
    const prevIndex = this.itinenaryDataSource.getValue().findIndex((d) => d === event.item.data);
    moveItemInArray(this.itinenaryDataSource.getValue(), prevIndex, event.currentIndex);
    this.itinenaryDataSource.next([...this.itinenaryDataSource.getValue()]);
    this.fileService.changeItinenaryData(this.itinenaryDataSource.getValue(), true);
  }

  enableDisableShift() {
    const selectedItems = this.highlightedRows; //this.selection.selected;
    if (selectedItems.length == 1) {
      const currentIndex = this.itinenaryDataSource.getValue().findIndex(item => item === selectedItems[0]);
      this.enableShiftDown = this.enableShiftUp = true;
      this.enableShiftUp = (currentIndex - 1) < 0 ? false : true;
      this.enableShiftDown = (currentIndex + 1) >= this.itinenaryDataSource.getValue().length ? false : true;
    } else {
      this.enableShiftDown = this.enableShiftUp = false;
    }
  }


  deleteItinerary(): void {
    this.fileService.writeLog("deleteItinerary-start").subscribe((res: any) => {
       if (res.responseCode != null && res.responseCode.statusCode === 401) {
        this.authService.logout();
        this.router.navigate(['/user/login']);
    } else {
          this.highlightedRows.forEach(multipleItem => {
          this.itinenaryDataSource.next(this.itinenaryDataSource.getValue().filter(item => item !== multipleItem))
          this.selection.clear();
          this.fileService.changeItinenaryData(this.itinenaryDataSource.getValue(), true);
      });
          this.highlightedRows.splice(0);
          this.fileService.writeLog("deleteItinerary-end").subscribe((data: any) => {    
        })
      }
    },
      (err) => console.log("Error while delete Itinerary: ", err)
    );
  }

  deleteAllItinerary(): void {
    this.fileService.writeLog("deleteAllItinerary-start").subscribe((res: any) => {
       if (res.responseCode != null && res.responseCode.statusCode === 401) {
        this.authService.logout();
        this.router.navigate(['/user/login']);
      } else {
        const message = "Are you sure to delete all the waypoints in the itinerary?"
        const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
          width: '30rem',
          data: message,
          disableClose: false
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result.saveData) {
            this.itinenaryDataSource.next([]);
            this.fileService.changeItinenaryData(this.itinenaryDataSource.getValue(), true);
            this.highlightedRows.splice(0);
          }
          this.fileService.writeLog("deleteAllItinerary-end").subscribe((data: any) => {})
        })
      }
    },
      (err) => console.log("Error while delete all itinerary: ", err)
    );
  }

  reverseItinerary(): void {
    this.fileService.writeLog("reverseItinerary-start").subscribe((res: any) => {
       if (res.responseCode != null && res.responseCode.statusCode === 401) {
        this.authService.logout();
        this.router.navigate(['/user/login']);
    } else { 
        this.itinenaryDataSource.next([...this.itinenaryDataSource.getValue()].reverse())
        this.enableDisableShift();
        this.fileService.changeItinenaryData(this.itinenaryDataSource.getValue(), true);
        this.fileService.writeLog("reverseItinerary-end").subscribe((data: any) => {    
        })
      }
    },
    (err) => console.log("Error while reverse itinerary: ", err)
  );
  }


  clickItinerary(rowData?: IWayPoint, event?: MouseEvent): void {
    if (event.shiftKey) {
      this.initValMultiSelect = true;
      const arrIdVals = [];
      let initialId = rowData.id; //In case there isn't previously value selected
      if(this.highlightedRows.length !== 0) { //Update value in case a previously value exist
        initialId = this.highlightedRows[0].id; 
      }
      
      const endId = rowData.id; //Get End Id from user request
      arrIdVals.push(initialId, endId);
      arrIdVals.sort((a, b) => a - b);// sort idVals

      const itinenaryData = this.itinenaryDataSource.getValue();
      itinenaryData.forEach(item => {
        const isWithinRange = item.id >= arrIdVals[0] && item.id <= arrIdVals[1]; //get items in between Ids 
        const isItemHighlighted = this.highlightedRows.includes(item); //avoiding duplications
        
        if (isWithinRange && !isItemHighlighted) {
          this.highlightedRows.push(item);
        }
      });
      this.enableDisableShift();

    } else {
      if (this.initValMultiSelect){
        this.highlightedRows.splice(0);
        this.initValMultiSelect = false;
      }
      const index = this.highlightedRows.indexOf(rowData);
      if (index !== -1) {
        this.highlightedRows.splice(index, 1);
      } else {
        this.highlightedRows = [rowData];
      }
      this.enableDisableShift();
    }
  }
  addEditItinerary(mode: string, rowData?: IWayPoint): void {
    this.fileService.writeLog("addEditItinerary-start").subscribe((res: any) => {
       if (res.responseCode != null && res.responseCode.statusCode === 401) {
        this.authService.logout();
        this.router.navigate(['/user/login']);
    } else {
        let data = null;
        //For 'Add' mode intialize the 'id' and 'sequenceId';
        if (mode === 'Add') {
          const length = this.itinenaryDataSource ? this.itinenaryDataSource.getValue().length + 1 : 1;
          const id = length, sequenceId = length;
          data = { id, sequenceId, mode };
        } else {
          data = { ...rowData, mode }
        }

        const dialogRef = this.crudDialog.open(ItinenaryCrudDialog, {
          width: '30rem',
          data,
          disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
          //Save the data if ONLY some data is passed via crudDialog
          if (result.saveData) {
            if (mode === 'Edit') {
              const index = this.itinenaryDataSource.getValue().findIndex(item => item.id === rowData.id)
              const newItinerary = [...this.itinenaryDataSource.getValue()];
              newItinerary[index] = result.wayPointVal;
              this.itinenaryDataSource.next(newItinerary);
            } else {
              this.itinenaryDataSource.next([...this.itinenaryDataSource.getValue(), result.wayPointVal]);
            }
            this.fileService.changeItinenaryData(this.itinenaryDataSource.getValue(), true);
          }
        });
        this.fileService.writeLog("addEditItinerary-end").subscribe((data: any) => {

        })
      } 
    },
      (err) => console.log("Error while add/Edit Itinerary: ", err)
    );    
  }

  getDirections() {
    this.fileService.writeLog("getDirections-start").subscribe((res: any) => {
       if (res.responseCode != null && res.responseCode.statusCode === 401) {
        this.authService.logout();
        this.router.navigate(['/user/login']);
      } else {
          this.mapService.changeGetMapDirections(true);
          this.fileService.writeLog("getDirections-end").subscribe((data: any) => {
        })
      }
    },
      (err) => console.log("Error while get directions: ", err)
    );
  }

  clearDirections() {
    this.fileService.writeLog("clearDirections-start").subscribe((res: any) => {
       if (res.responseCode != null && res.responseCode.statusCode === 401) {
        this.authService.logout();
        this.router.navigate(['/user/login']);
      } else {
        this.mapService.changeClearMapDirections(true);
        this.fileService.writeLog("clearDirections-end").subscribe((data: any) => {})
      }
    },
      (err) => console.log("Error while clear directions: ", err)
    );
  }

  @HostListener('document:MouseEvent', ['$event.target'])
  displaySelectedItineraryitem(event) {
    this.fileService.writeLog("displaySelectedItineraryitem-start").subscribe((res: any) => {
      if (res.responseCode != null && res.responseCode.statusCode === 401) {
        this.authService.logout();
        this.router.navigate(['/user/login']);
      } else {
        this.highlightedRows = this.selection.selected;
        if (this.highlightedRows.length !== 1) {
          if (event.shiftKey === true) {
            const value = this.itinenaryDataSource.value;
            const maxValue = this.highlightedRows.reduce((prev, current) => (+prev.id > +current.id) ? prev : current)
            const minValue = this.highlightedRows.reduce((prev, current) => (+prev.id < +current.id) ? prev : current)
            var i = minValue.id   // Minimum Value               
            if (this.highlightedRows.length > 1) {
              this.ItemFilteredLists = []
              for (i; i < maxValue.id; i++) {
                this.ItemFilteredList = value.filter(book => book.id === i);
                for (let lists of this.ItemFilteredList) {
                  this.ItemFilteredLists.push(lists)
                }
              }
    
              if (this.ItemFilteredLists != undefined && this.ItemFilteredLists.length != 0) {
                var newselectedItem = this.highlightedRows.concat(this.ItemFilteredLists)
                newselectedItem = newselectedItem.filter((el, i, a) => i === a.indexOf(el))
                newselectedItem.sort((a, b) => 0 - (a.id > b.id ? -1 : 1));
                if (this.highlightedRows.indexOf(newselectedItem) === -1) {
                  this.highlightedRows = this.highlightedRow.concat(newselectedItem);
                }
                else {
                  this.highlightedRows[this.highlightedRows.indexOf(newselectedItem)] = -1;
                }
                for (let item of this.highlightedRows) {
                  this.mapService.showSelectedItineraryItem({
                    latitude: item.latitude,
                    longitude: item.longitude
                  })
                }
              }
            }
    
          }
          else if (event.shiftKey === false && event.type != "click") {
            this.ItemFilteredLists = [];
            for (let item of this.highlightedRows) {
              this.mapService.showSelectedItineraryItem({
                latitude: item.latitude,
                longitude: item.longitude
              })
            }
    
          }
          else if (event.ctrlKey === true) {
            this.ItemFilteredLists = [];
            for (let item of this.highlightedRows) {
              this.mapService.showSelectedItineraryItem({
                latitude: item.latitude,
                longitude: item.longitude
              })
            }
    
          }
          else if (event.type === "click") {
            this.ItemFilteredLists = [];
            this.ItemFilteredLists = this.highlightedRows.filter(b => b.hovered === false)
            this.ItemFilteredLists.forEach(s => {
              this.selection.deselect(s)
            });
            this.ItemFilteredLists = this.highlightedRows.filter(b => b.hovered === true)
            for (let val of this.highlightedRows) {
              let indexNumber = val.id;
              this.distancePopupMethod(indexNumber);
    
            }
    
            for (let item of this.ItemFilteredLists) {
              this.mapService.showSelectedItineraryItem({
                latitude: item.latitude,
                longitude: item.longitude
              })
            }
    
          }
          //  })
          //  })// foreach
          // }
        }
        else {
          this.ItemFilteredLists = [];
          this.ItemFilteredLists = this.highlightedRows.filter(b => b.hovered === false)
          //this.fileService.selectrdMarker$=this.highlightedRows[0];
          this.ItemFilteredLists.forEach(s => {
            this.selection.deselect(s)
    
          });
    
          this.ItemFilteredLists = this.highlightedRows.filter(b => b.hovered === true);
          for (let item of this.ItemFilteredLists) {
            let value = item.id
            this.distancePopupMethod(value);
            this.mapService.showSelectedItineraryItem({
              latitude: item.latitude,
              longitude: item.longitude
            })
          }
        }
        if(this.selection.selected.length==1) {
          this.fileService.isItineraryListMarker=true;
          this.fileService.selectrdMarker(this.selection.selected[0]);
        }
        this.fileService.writeLog("displaySelectedItineraryitem-end").subscribe((data: any) => {
        });
      }
    },
      (err) => console.log("Error while display selected itinerary item: ", err)
    );    
  }

  distancePopupMethod(id: any) {
    this.distances = [] = [];
    // console.log(this.distances)
    this.distances = this.returndata();
    this.routePopupContentList = this.returnRoutePopup();
    this.routeMarkerList = this.returnRouteMark();
    this.particularWaypointDistance(id)
    // console.log(this.distances)

  }

  particularWaypointDistance(id: any) {
    let chunks = id;
    let totaldis = [];
    let totalTimeCalculate = [];
    let currentDistance = [];
    for (let i = 0, j = this.distances.length; i < j; i = chunks) {
      currentDistance = this.distances.slice(i, i + chunks);
      break;
    }
    for (let firstdis of currentDistance) {
      if (firstdis.distance != "0km") {
        let convertDistanceFloatValue = parseFloat(firstdis.distance);
        totalTimeCalculate.push(firstdis.time)
        const sum = totalTimeCalculate.reduce((acc, time) => acc.add(moment.duration(time)), moment.duration());
        let timeValue = [Math.floor(sum.asHours()), sum.minutes()].join(':')

        let convertTimeFloatValue = firstdis.time.replace(":", ".");
        let time = parseFloat(convertTimeFloatValue);
        totaldis.push(convertDistanceFloatValue);
        totalTimeCalculate.push(time);
        let distanceValue = totaldis.reduce((a, b) => a + b, 0);
        this.totalDistances = distanceValue.toFixed(2);
        this.totalTimes = timeValue.toString() + "h";
        //  this.totalTimes=this.totalTimes.replace(".",":"); // TOTAL TIME VALUE
        this.totalDistances = this.totalDistances.toString() + "km";    //TOTAL DISTANCE VALUE
      }
    }
    this.bindMethod(id, this.totalDistances, this.totalTimes);
  }

  bindMethod(ids?: any, distance?: any, totalTime?: any) {
    this.distances.forEach((waypoint, index) => {
      if (index !== 0 && this.routeMarkerList[index]) {
        if (this.routeMarkerList.length == 2) {
          this.routeMarkerList[index].bindPopup(`${this.routePopupContentList[index]}
        <strong>Distance :</strong> ${waypoint.distance}(${waypoint.time}h)/${distance}(${totalTime}) `);
        }
        else {
          this.routeMarkerList[index].bindPopup(`${this.routePopupContentList[index]}
        <strong>Distance :</strong> ${waypoint.distance}(${waypoint.time}h)/${distance}(${totalTime}) `);
        }

        if (ids && distance) {
          if (ids >= 1800) {
            if (this.routeMarkerList.length == 2) {
              this.routeMarkerList[index].bindPopup(`${this.routePopupContentList[ids]}
          <strong>Distance :</strong> ${waypoint.distance}(${waypoint.time}h)/${distance}(${totalTime}) `);
            }
            else {
              this.routeMarkerList[index].bindPopup(`${this.routePopupContentList[ids]}
          <strong>Distance :</strong> ${waypoint.distance}(${waypoint.time}h)/${distance}(${totalTime}) `);
            }
          }

        }
      }

    });
  }


  highlightRows(id: any) {
    this.ItemFilteredLists = [];
    this.highlightedRows = this.itinenaryDataSource.value.filter(d => d.id === id)
    this.ItemFilteredLists=this.highlightedRows.filter(b=>b.hovered===false) 
    this.ItemFilteredLists.forEach(s=>{
      this.selection.deselect(s);    
    });         
   // this.highlightedRows.filter(b => b.hovered == true)
    // for(let item of this.ItemFilteredLists){        
    //   this.mapService.showSelectedItineraryItem({
    //   latitude:  item.latitude,
    //   longitude:  item.longitude
    //  })

    // } 
  }

  optimiseItinerary() {   
    this.fileService.writeLog("optimiseItinerary-start").subscribe((res: any) => {
      if (res.responseCode != null && res.responseCode.statusCode === 401) {
        this.authService.logout();
        this.router.navigate(['/user/login']);
      } else {
        if (this.itinenaryDataSource.value.length > 25) {
            const message =
                "optimization is maximum twentyfive waypoints";
              const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
                width: "28rem",
                data: message,
                disableClose: false,
              });
              dialogRef.afterClosed().subscribe((result) => {
                if (result.saveData) {
              //   this.mapService.initiateOptimiseItinerary(true);
                }
              });   
            this.fileService.writeLog("optimiseItinerary-end").subscribe((data: any) => {})
        } else if(this.itinenaryDataSource.value.length < 25) {
            this.mapService.initiateOptimiseItinerary(true)
          }
      }
    },
      (err) => console.log("Error while optimise itinerary: ", err)
    );
  }
  

  showEntireItinerary() {
    this.fileService.writeLog("showEntireItinerary-start").subscribe((res: any) => {
       if (res.responseCode != null && res.responseCode.statusCode === 401) {
        this.authService.logout();
        this.router.navigate(['/user/login']);
      } else {
        this.mapService.showAllWaypoint(true);
        this.fileService.writeLog("showEntireItinerary-end").subscribe((data: any) => {})
      }
    },
      (err) => console.log("Error while show entire itinerary: ", err)
    );   
  }

  showUTurn() {
    this.fileService.writeLog("showSingleCalculation-start").subscribe((res: any) => {
       if (res.responseCode != null && res.responseCode.statusCode === 401) {
        this.authService.logout();
        this.router.navigate(['/user/login']);
      } else {
        // SHOW WARNING MESSAGE WHEN CLICK ON UTRUN BUTTON
        if (this.itinenaryDataSource.value.length != 0) {
          const message =
            "Warning. Usage of this function will result in additional cost for company Please only use when needed to locate waypoint issues in imported routes. With this function the imported route will not be calculated in a single batch. The route will be calculated from waypoint to waypoint in single steps. At the point where calculation stops, you will find the issue.";
          const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
            width: "28rem",
            data: message,
            disableClose: false,
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result.saveData) {
              this.disabledUTurn = true;
              this.mapService.enableUTurnItinerary(true);
            }
          });
          this.fileService.writeLog("showSingleCalculation-end").subscribe((data: any) => {})
        }
      }
    },
      (err) => console.log("Error while show single calculation: ", err)
    ); 
  }

  ngOnDestroy(): void {
    // Clear up resources    
    this.subs.forEach(sub => sub.unsubscribe());
    this.fileService.changeItinenaryData([], false);
    this.fileService.changeItineraryName('');

  }

  public selectRowsBetween(start, end) {
    let currentIndex = 0;
    this.selectedItem.forEach(row => {
      if (currentIndex >= start && currentIndex <= end) {
        this.selection.select(row);
      }
      currentIndex++;
    });
  }
}
